import React, {Component} from 'react';
import './ConfirmEstonianCompany.scss';
import {connect} from 'react-redux';
import ButtonInput from "../../components/Common/ButtonInput";
import {Api} from "../../api";
import {checkAuth, getAuthToken} from "../../utils";

class ConfirmEstonianCompany extends Component {
    state = {
        certificateId: '',
        name: '',
        taxNumber: '',
        countryTitle: '',
        validTill: '',
        companyName: '',
        companyCode: '',
        role: '',
        isLoading: true,
        agreementConfirmed: false,
        checkedInRegistry: false
    };

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate() {
    }

    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        const companyStr = localStorage.getItem('registration-company');
        if (!companyStr) {
            this.props.history.push('/user/personal-data/certificate-type-selection');
            return;
        }
        const company = JSON.parse(companyStr);
        this.setState({
            name: company.name,
            taxNumber: company.taxNumber,
            countryTitle: company.countryTitle,
            validTill: company.validTill,
            companyCode: company.companyCode,
            companyName: company.companyName,
            certificateId: company.certificateId,
            isLoading: false
        });
        console.log('company str');
        console.log(companyStr);
        this.props.handleLoader(false);
    }


    agree = () => {
        this.setState({agreementConfirmed: !this.state.agreementConfirmed});
    };

    cancel = () => {
        this.props.history.push('/user/personal-data/search-for-companies');
    };

    confirm = () => {
        if (!this.state.agreementConfirmed) {
            alert('Please agree with condition');
            return;
        }

        const auth = getAuthToken();
        Api.get('rik/check-company?taxNumber=' + this.state.taxNumber + '&companyCode=' + this.state.companyCode, auth)
            .then(response => {
                this.setState({checkedInRegistry: true, role: response.data.role});
            }).catch(error => {
                alert('Your certificate hasn\'t found in company signatures');
            this.props.history.push('/user/personal-data/search-for-companies');
        });
    };

    addCompany = () => {
        const auth = getAuthToken();
        const body = {
            certificateId: this.state.certificateId,
            name: this.state.companyName,
            taxNumber: this.state.companyCode,
            role: this.state.role
        };
        Api.post('company/add-company', body, auth)
            .then(response => {
                console.log('Success');
                localStorage.removeItem('registration-company');
                this.props.history.push('/user/personal-data/wait-for-payment');
            }).catch(error => {
                checkAuth(error, this.props.history);
        })
    };

    render() {
        const {name, isLoading, taxNumber, countryTitle, validTill, companyName, companyCode, agreementConfirmed, checkedInRegistry} = this.state;
        const expDate = new Date(validTill);

        return (!isLoading &&
            <div className={'content-wrapper'}>
                <div className={'content'}>
                    <div className={'row'}>
                        <div className={'col-lg-5'}>
                            <div className={'row'}>
                                <div className={'col-lg-12'}>
                                    <label className="field-hint-label">Name</label>
                                </div>
                                <div className={'col-lg-12'}>
                                    <input className="payment-descr-input" type="text"
                                           disabled="true" value={name}/>
                                </div>
                            </div>
                        </div>
                        <div className={'col-lg-5 offset-lg-1'}>
                            <div className={'row'}>
                                <div className={'col-lg-12'}>
                                    <label className="field-hint-label">Jurisdiction of incorporation</label>
                                </div>
                                <div className={'col-lg-12'}>
                                    <input className="payment-descr-input" type="text"
                                           disabled="true" value={countryTitle === 'EE' ? 'Estonia' : countryTitle}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'row margin-top-25'}>
                        <div className={'col-lg-5'}>
                            <div className={'row'}>
                                <div className={'col-lg-12'}>
                                    <label className="field-hint-label">Personal code</label>
                                </div>
                                <div className={'col-lg-12'}>
                                    <input className="payment-descr-input" type="text"
                                           disabled="true" value={taxNumber}/>
                                </div>
                            </div>
                        </div>
                        <div className={'col-lg-5 offset-lg-1'}>
                            <div className={'row'}>
                                <div className={'col-lg-12'}>
                                    <label className="field-hint-label">Expiration date</label>
                                </div>
                                <div className={'col-lg-12'}>
                                    <input className="payment-descr-input" type="text"
                                           disabled="true" value={expDate.toLocaleDateString()}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'row margin-top-25'}>
                        <div className={'col-lg-5'}>
                            <div className={'row'}>
                                <div className={'col-lg-12'}>
                                    <label className="field-hint-label">Company</label>
                                </div>
                                <div className={'col-lg-12'}>
                                    <input className="payment-descr-input" type="text"
                                           disabled="true" value={companyName}/>
                                </div>
                            </div>
                        </div>
                        <div className={'col-lg-5 offset-lg-1'}>
                            <div className={'row'}>
                                <div className={'col-lg-12'}>
                                    <label className="field-hint-label">Company ID</label>
                                </div>
                                <div className={'col-lg-12'}>
                                    <input className="payment-descr-input" type="text"
                                           disabled="true" value={companyCode}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    {!checkedInRegistry ?
                        <div>
                            <div className={'row margin-top-25'}>
                                <div className={'offset-lg-3 col-lg-6'}>
                                    <textarea className={'form-control'} id={'agreement-company'}
                                    defaultValue={'I hereby confirm that the I am authorized representative of the company and information provided by me is true. I consent to this' +
                                    ' information being verified by TransferSign service checking National companies register.'}/>
                                    <div id={'agreement-check-box-block'}>
                                            <input className={'big-checkbox'} type="checkbox"
                                                   id={'agree-check-box'}
                                                   checked={!!agreementConfirmed}
                                                   onChange={(e) => {this.agree()}}/>
                                            <label>I agree.</label>
                                    </div>
                                </div>
                            </div>

                            <div className={'row margin-top-10'}>
                                <div className={'col-lg-3 offset-lg-3'}>
                                    <div className={'fields-row padding-left-35'}>
                                        <ButtonInput
                                            id="new-search-button"
                                            className={'dark-button black-btn search-bth'}
                                            title='Cancel'
                                            handleClick={(e) => this.cancel()}/>
                                    </div>
                                </div>
                                <div className={'col-lg-3'}>
                                    <div className={'fields-row'}>
                                        <ButtonInput
                                            id="search-button"
                                            className={'dark-button black-btn search-bth'}
                                            title='Confirm'
                                            handleClick={(e) => this.confirm()}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className={'row margin-top-45'}>
                                <div className={'offset-lg-4 col-lg-6 padding-left-50'}>
                                    <span className={'green-shield-icon ee-com-icon'}></span>
                                    <label className={'bold'}>Signature authority is verified</label>
                                </div>
                            </div>
                            <div className={'row  margin-top-25'}>
                                <div className={'col-lg-3 offset-lg-3 margin-top-10'}>
                                    <div className={'fields-row padding-left-35'}>
                                        <ButtonInput
                                            id="new-search-button"
                                            className={'dark-button black-btn search-bth'}
                                            title='Cancel'
                                            handleClick={(e) => this.cancel()}/>
                                    </div>
                                </div>
                                <div className={'col-lg-3 margin-top-10'}>
                                    <div className={'fields-row'}>
                                        <ButtonInput
                                            id="search-button"
                                            className={'dark-button black-btn search-bth'}
                                            title='Add company'
                                            handleClick={(e) => this.addCompany()}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(ConfirmEstonianCompany);


// WEBPACK FOOTER //
// ./src/views/ConfirmEstonianCompany/ConfirmEstonianCompany.js